import { defineStore } from 'pinia'
import { api } from '@/plugins/axios';
import { useCartStore } from './cart';
import { useAuthStore } from './authStore';

export const useCheckoutStore = defineStore('checkout-store', {
  state: () => ({
    loading: false,
    errorMessage: '',
    checkoutData: {
      store_id: '',
      pickup_datetime: '',
      order_notes: '',
      first_name: '',
      last_name: '',
      mobile_no: '',
      email: '',      
      billing_address1: '',
      billing_address2: '',
      billing_city: '',
      billing_state: '',
      billing_zipcode: '',
      payment_option: 'paypal',
    },   
    initialCheckoutData: {
      store_id: '',
      pickup_datetime: '',
      order_notes: '',
      first_name: '',
      last_name: '',
      mobile_no: '',
      email: '',   
      billing_address1: '',
      billing_address2: '',
      billing_city: '',
      billing_state: '',
      billing_zipcode: '',
      payment_option: 'paypal',   
    },       
  }),

  getters: {},

  actions: {    
    async createOrder() {
      const authStore = useAuthStore()
      const cartStore = useCartStore()
      let payload = {
        store_id: this.checkoutData.store_id,
        pickup_datetime: this.checkoutData.pickup_datetime,
        order_notes: this.checkoutData.order_notes,
        first_name: this.checkoutData.first_name,
        last_name: this.checkoutData.last_name,
        mobile_no: this.checkoutData.mobile_no,
        email: this.checkoutData.email,
        billing_address1: this.checkoutData.billing_address1,
        billing_address2: this.checkoutData.billing_address2,
        billing_city: this.checkoutData.billing_city,
        billing_state: this.checkoutData.billing_state,
        billing_zipcode: this.checkoutData.billing_zipcode,
        payment_type: this.checkoutData.payment_option,        
        cart: cartStore.cart,
        coupon_code: cartStore.coupon,
        dilevery_charge: cartStore.deliveryCharge
      } 
      if(authStore.user){
        payload.user_id = authStore.user.id
      }
      const response = await api.post('/paypal/create-order', payload)
      return response
    },
    async captureOrder(orderID) {
      const response = await api.post('/paypal/capture-order', { order_id: orderID })
      return response
    },
  }
});
